import React from 'react'
import Helmet from 'reactor/components/Helmet'
import BreadcrumbWithImage from '../../../components/BreadcrumbWithImage'
import BreadcrumbImage from 'assets/images/webLayer.png'
import Heading from '../../../components/heading'
import Container from 'reactor/components/Grid/ContainerWithWidth'
import "../AddOnWeb.scss"
import "./PrivacyPage.scss"
const data = [
    'تمكننا من تطوير المنتجات والخدمات أو تحسينها أو تسويقها أو تقديمها لعملائنا.',
    'تمكننا من دعم عمليات وتشغيل الأنظمة اللازمة لضمان استمرارية تقديم الخدمات بالجودة المطلوبة وتقديم فوترة دقيقة لتمكيننا من تسوية مدفوعات المنتجات والخدمات.',
    'فهم احتياجاتك كعميل ومدى مناسبة المنتجات والخدمات لك وتقديم توصيات لمنتجات وخدمات معينة تكون ذات صلة بك.',
    'التواصل معك عن المنتجات والخدمات الجديدة التي جرى إطلاقها.',
    'حل ومعالجة الاستفسارات أو الشكاوى التي قد تكون لديك وتحسين تجربة العميل عبر جميع قنوات التواصل لتكون ثرية ومُخصصة.',
    ' نحتاج أيضًا إلى جمع البيانات الشخصية ومعالجتها لتلبية المتطلبات القانونية والتنظيمية.'
]

const whyData = [
    'البيانات التي تزودنا بها والتي تكون مطلوبة عند التسجيل في خدماتنا (مثل الاسم وعنوان البريد الإلكتروني والعنوان ورقم الهاتف والجنسية).',
    'البيانات التي نحصل عليها من استخدامك لخدماتنا أو مواقع الويب أو تطبيقات الهاتف المحمول (مثل ملفات تعريف الارتباط وبيانات الاستخدام).',
    'البيانات المُتبادلة خلال تواصلنا معك (مثل طلبات خدمات دعم العملاء والملاحظات المُستلمة منك).',
    'البيانات المُستلمة من الأجهزة التي تساعد في تقديم توصيات حيال منتجاتنا ولحل الشكاوى التقنية (مثل معَرّف الجهاز).',
    'في كل مرة تستخدم فيها خدمتنا في حالة وجود خطأ في النظام، نقوم بجمع البيانات والمعلومات (من خلال منتجات طرف ثالث) على جهازك تسمى البيانات المسجلة. قد تتضمن البيانات المسجلة هذه معلومات مثل عنوان بروتوكول الإنترنت (IP) الخاص بجهازك واسم الجهاز ونسخة نظام التشغيل ترتيب النظام عند استخدام الخدمة ووقت وتاريخ استخدامك للخدمة وغيرها من الإحصاءات.'
]

const providers = [
    'لتسهيل خدمتنا.',
    'لتقديم الخدمة نيابة عنا.',
    'لتنفيذ الخدمات ذات الصلة بالخدمة.',
    'لمساعدتنا في تحليل كيف يتم استخدام خِدمتنا.',
    'نودّ إعلام مستخدمي هذه الخدمة بأن هذه الجهات الخارجية لديها حق الوصول إلى معلوماتك الشخصية. والسبب هو تنفيذ المهام الموكلة إليهم نيابة عنا. فهي ملزمة بعدم الكشف عن أو استخدام المعلومات لأي غرض آخر.'
]


export default function PrivacyPage() {

    return(
        <>
            <Helmet bodyClass="privacy" 
            title="سياسة الخصوصية | رواد لخدمات الويب خبرة أكثر من 12 عام في السوق السعودي"
            description="نقوم بجمع بياناتك الشخصية ونستخدمها لمساعدتنا في أن نوفر لك المنتجات والخدمات بأعلى معايير الجودة"
            />

            <BreadcrumbWithImage
                text="سياسة الخصوصية"
                subtext="تحترم شركة رواد الاستضافة لتقنية المعلومات خصوصيتك ويتمثل هدفنا في تقديم خدمة ذات جودة عالية لجميع عملائنا و موظفينا وشركائنا. وجرى صياغة سياسة الخصوصية هذه لمساعدتك على فهم طبيعة البيانات التي نجمعها منك وكيفية تعاملنا مع هذه البيانات الشخصية. ومن المهم أن تكون على دراية بكيفية استخدامنا لبياناتك الشخصية و حقوقك بصفتك عميل عند مشاركة بياناتك معنا ووفقا لأنظمة وتشريعات البيانات في المملكة العربية السعودية."
                img={BreadcrumbImage}
            />

            <div className="add__on">
                <Container block={true}>
                        <div className="add__on--content">
                            <Heading
                                title="لماذا نجمع بياناتك الشخصية ونستخدمها"
                                subtitle="نقوم بجمع بياناتك الشخصية ونستخدمها لمساعدتنا في أن نوفر لك المنتجات والخدمات بأعلى معايير الجودة.، على سبيل المثال:"
                            />
                            <div className="add__on--features">
                                <ul className="list-unstyled">
                                    {data.map((feature, index) => (
                                        <li key={index}>{feature}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="add__on--content">
                            <Heading
                                title="ما هي البيانات الشخصية التي نجمعها ونستخدمها"
                                subtitle="فيما يلي الأنواع الرئيسة للبيانات الشخصية التي نجمعها عنك ونستخدمها:ـ"
                            />
                            <div className="add__on--features">
                                <ul className="list-unstyled">
                                    {whyData.map((feature, index) => (
                                        <li key={index}>{feature}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="add__on--content">
                            <Heading
                                title="مقدميّ الخدمة"
                                subtitle="قد نوظف جهات خارجية وأفراد للأسباب التالية:"
                            />
                            <div className="add__on--features">
                                <ul className="list-unstyled">
                                    {providers.map((feature, index) => (
                                        <li key={index}>{feature}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <Heading
                            title="بيانات الكوكيز"
                            subtitle="هي ملفات تحتوي على كمية صغيرة من البيانات التي يتم استخدامها بشكل شائع كمعرّفات فريدة مجهولة الهوية. يتم إرسالها إلى متصفحك من مواقع الويب التي تزورها ويتم تخزينها على الذاكرة الداخلية لجهازك. لا تستخدم هذه الخدمة 'بيانات الكوكيز' بشكل صريح. ومع ذلك، قد يستخدم النظام رمزًا تابعًا لجهة خارجية يستخدم 'بيانات الكوكيز' لجمع المعلومات وتحسين خدماتها. لديك الخيار إما بقبول أو رفض بيانات الكوكيز هذه ومعرفة متى يتم إرسال البيانات إلى جهازك. إذا اخترت رفض خاصية بيانات الكوكيز الخاصة بنا، فقد لا تتمكن من استخدام بعض أجزاء هذه الخدمة."
                        />
                        <Heading
                            title="الخصوصية"
                            subtitle="نقدّر ثقتكم في تزويدنا معلوماتكم الشخصية، فإننا نسعى جاهدين لاستخدام وسائل مقبولة تجاريًا لحمايتها. ولكن تذكّر أنه لا توجد طريقة للإرسال عبر الإنترنت أو طريقة تخزين إلكترونية آمنة وموثوقة بنسبة كاملة، ولا يمكننا ضمان أمنها بشكل كامل."
                        />
                        <Heading
                            title="تغيّرات على سياسة الخصوصية هذه"
                            subtitle="قد نحدّث سياسة الخصوصية الخاصة بنا من وقت لآخر. لذا ننصحك بمراجعة هذه الصفحة بشكل دوري لأية تغيّرات. سنعلمك بأي تغيّرات عن طريق نشر سياسة الخصوصية الجديدة على هذه الصفحة. تعد هذه التغيّرات فعالة فور نشرها على هذه الصفحة."
                        />
                </Container>
            </div>
        </>
    )
}
